import { FormikContextType, getIn } from 'formik';

import { getFieldName } from '@features/Address/utils';

type FormProps<T, F> = Pick<
  FormikContextType<T>,
  | 'errors'
  | 'values'
  | 'handleChange'
  | 'handleBlur'
  | 'touched'
  | 'submitCount'
> & { formName: F; isLoading?: boolean };

type ValidationStatus = 'valid' | 'invalid' | undefined;

const useNestedFieldProps = <T, FormName extends keyof T>(
  formProps: FormProps<T, FormName>
) => {
  return <Field extends keyof T[FormName]>(name: Field) => {
    const {
      errors,
      values,
      handleChange,
      handleBlur,
      touched,
      submitCount,
      formName,
      isLoading,
    } = formProps;

    const value = values[formName] ? values[formName][name] : undefined;

    // FIXME: Assertions are bad
    const nameAssertion = name as string;
    const formNameAssertion = formName as string;

    const fieldName = getFieldName(formNameAssertion, nameAssertion);
    const error = getIn(errors, fieldName, undefined);
    const isTouched = getIn(touched, fieldName, false);

    let validationStatus: ValidationStatus;

    if (error && isTouched) {
      validationStatus = 'invalid';
    } else if (!error && value) {
      validationStatus = 'valid';
    } else {
      validationStatus = undefined;
    }

    return {
      name: fieldName,
      id: fieldName,
      value,
      onChange: handleChange,
      onBlur: handleBlur,
      validationText: isTouched || submitCount > 0 ? error : undefined,
      validationStatus,
      loading: isLoading,
    };
  };
};

export { useNestedFieldProps };
